module.exports = __webpack_public_path__ + "static/media/dark_dashboard_bg.eb336c92.jpg";